<template>
  <layout-component>
    <div class="banner banner-events">
      <div class="container">
        <div class="row d-md-flex justify-content-md-center">
          <div class="col-md-12">
              <div class="bullets">
              <h1 class="left-bullet" v-html="$t('w.events.title-banner')"></h1>
              <h2 class="right-bullet" v-html="$t('w.events.subtitle-banner')"></h2>
              </div>
          </div>
          </div>

          <nav>
              <ul class="categories nav-list">
                  <li class="nav-item"><router-link class="nav-link" to="/events" :class="{'active': $route.path == '/events'}">{{ $t('w.events.all') }}</router-link></li>
                  <li v-for="(category) in categories" class="nav-item" :key="category.id">
                      <router-link class="nav-link" :to="'/events/category/'+category.id" active-class="active">{{ $i18n.locale == 'fr' ? category.name : category.name_en }}</router-link>
                  </li>
              </ul>

          </nav>

      </div>
    </div>
    <div class="container">
        <div class="listing-events row">
          <div v-for="event in events" class="card-event event col-12" :key="event.id">
            <router-link :to="'/events/'+event.slug">
              <div class="img-wrapper">
                <div class="noise">
                    <div class="ratio">
                      <img class="img-fluid"  v-if="event.cover" :src="'/storage/'+event.cover" loading="lazy" :alt="$i18n.locale == 'fr' ? event.name : event.name_en" />
                    </div>
                </div>
              </div>
              <div class="category-wrapper">
                <span class="category">{{ $i18n.locale == 'fr' ? event.category.name : event.category.name_en }}</span>
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="3" height="3" viewBox="0 0 3 3">
                    <circle id="Ellipse_12" data-name="Ellipse 12" cx="1.5" cy="1.5" r="1.5" fill="#7b947b"/>
                  </svg>
                </span>
                <span class="level">{{event.label.name }}</span>
              </div>
              <div class="text-wrapper">
                <h3>{{ $i18n.locale == 'fr' ? event.name : event.name_en }}</h3>
                <div v-if="event.end_date && (event.start_date != event.end_date)" class="event-dates">
                  <p>{{'w.events.from'|t}} {{ event.start_date | formatDateEvent }}</p>
                  <p>{{'w.events.to'|t}} {{ event.end_date | formatDateEvent }}</p>
                </div>
                <div v-else class="event-dates">
                  <p>{{ event.start_date | formatDateEvent }}</p>
                </div>
                <p class="event-hours">
                  <span>
                    {{ event.from | formatTimeEvent }}
                  </span>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="5.447" height="9.48" viewBox="0 0 5.447 9.48">
                      <path id="Tracé_1" data-name="Tracé 1" d="M428.9,772l4.386,4.387-4.386,4.386" transform="translate(-428.547 -771.646)" fill="none" stroke="#03f462" stroke-width="1"/>
                    </svg>
                  </span>
                  <span>
                    {{ event.to | formatTimeEvent }}
                  </span>
                </p>
              </div>
            </router-link>
          </div>
        </div>
    </div>

    <div class="container mb-4" v-if="datas != null && datas.last_page > 1">
      <div class="row d-flex justify-content-center">
        <Pagination :data="datas"></Pagination>
      </div>
    </div>
  </layout-component>
</template>

<script>
export default {
  data() {
    return {
      events:null,
      datas: null,
      categories:null,
      page: 1
    }
  },
  mounted(){
    if (this.$route.query.page) {
      this.page = this.$route.query.page
    }
    this.fetchData();
  },
  methods: {
    fetchData() {
      Vue.axios.get('/eventscategories').then( ({data}) => {
          this.categories = data
      }).catch(() => {});

      if(this.$route.params.id) {
          Vue.axios.get(`/events/category/${this.$route.params.id}?page=${this.page}`).then(({data}) => {
            this.datas = data
            this.events = data.data
          }).catch(() => {})
      }else{
          Vue.axios.get(`/events?page=${this.page}`).then( ({data}) => {
            this.datas = data
            this.events = data.data
          }).catch(() => {});
      }
    },
  }
}
</script>
